import {
  CourseInstanceAttendee,
  CourseInstanceAttendeeStatus,
  DisplayedCourseInstance,
} from '../types/CourseInstance';
import { CertificateLanguage } from '../../certificate/types/Certificate';
import { t } from 'i18next';

export const getCertificateDownloadTooltip = (
  selectedAttendees: CourseInstanceAttendee[],
  courseInstance: DisplayedCourseInstance,
  certificateLanguages: CertificateLanguage[],
) => {
  const hasPassedAttendee = !!selectedAttendees.find(
    (attendee) => attendee.status === CourseInstanceAttendeeStatus.Passed,
  );

  if (selectedAttendees.length === 0) {
    return t('components.CourseInstanceCard.classNoPassedAttendees');
  } else if (!courseInstance.instructor || !courseInstance.startsAt) {
    return t('components.CourseInstanceCard.classMissingInstructorStartsAt');
  } else if (!hasPassedAttendee) {
    return t('components.CourseInstanceCard.onlyPassedAttendees');
  } else if (certificateLanguages.length == 0) {
    return t('components.CourseInstanceCard.noTemplateAvailable');
  }
  return undefined;
};

export const getCertificateEmailTooltip = (
  selectedAttendees: CourseInstanceAttendee[],
  courseInstance: DisplayedCourseInstance,
  certificateLanguages: CertificateLanguage[],
) => {
  const hasPassedAttendee = !!selectedAttendees.find(
    (attendee) => attendee.status === CourseInstanceAttendeeStatus.Passed,
  );

  if (selectedAttendees.length === 0) {
    return t('components.CourseInstanceCard.classNoPassedOrNoEmailAttendees');
  } else if (!courseInstance.instructor || !courseInstance.startsAt) {
    return t('components.CourseInstanceCard.classMissingInstructorStartsAt');
  } else if (!hasPassedAttendee) {
    return t('components.CourseInstanceCard.onlyPassedAttendees');
  } else if (certificateLanguages.length == 0) {
    return t('components.CourseInstanceCard.noTemplateAvailable');
  }
  return undefined;
};
